import React from 'react';
import { StarIcon } from "@heroicons/react/24/solid";

const staticFilterSections = [
   {
      title: "Ratings",
      type: "rating",
      key: "rating",
      items: [
         { value: 4.5, label: "4.5 & up", count: 1991 },
         { value: 4.0, label: "4.0 & up", count: 200 },
         { value: 3.5, label: "3.5 & up", count: 300 },
         { value: 3.0, label: "3.0 & up", count: 500 }
      ]
   },
   {
      title: "Instructors",
      type: "checkbox",
      key: "instructors",
      items: [
         { id: "1", name: "Jane Cooper", count: 18 },
         { id: "2", name: "Jenny Wilson", count: 12 },
         { id: "3", name: "Robert Fox", count: 23 },
         { id: "4", name: "Jacob Jones", count: 67 },
         { id: "5", name: "Albert Flores", count: 34 }
      ],
      showMore: true
   },
   {
      title: "Price",
      type: "radio",
      key: "price",
      items: [
         { value: "All", name: "All", count: 18 },
         { value: "Free", name: "Free", count: 12 },
         { value: "Paid", name: "Paid", count: 23 }
      ]
   },
   {
      title: "Level",
      type: "checkbox",
      key: "level",
      items: [
         { value: "All Levels", name: "All Levels", count: 18 },
         { value: "Beginner", name: "Beginner", count: 12 },
         { value: "Intermediate", name: "Intermediate", count: 23 },
         { value: "Expert", name: "Expert", count: 67 }
      ]
   },
   {
      title: "Language",
      type: "checkbox",
      key: "language",
      items: [
         { value: "English", name: "English", count: 18 },
         { value: "French", name: "French", count: 12 },
         { value: "German", name: "German", count: 23 },
         { value: "Italian", name: "Italian", count: 67 },
         { value: "Turkish", name: "Turkish", count: 34 }
      ],
      showMore: true
   },
   {
      title: "Duration",
      type: "checkbox",
      key: "duration",
      items: [
         { value: "Less than 3 hours", name: "Less than 3 hours", count: 18 },
         { value: "4 - 7 hours", name: "4 - 7 hours", count: 12 },
         { value: "8 - 18 hours", name: "8 - 18 hours", count: 23 },
         { value: "20 + Hours", name: "20 + Hours", count: 67 }
      ]
   }
];

const FiltersPanel = ({ showFilters, onFilterChange, selectedFilters, categories = [] }) => {
   const categorySection = {
      title: "Category",
      type: "checkbox",
      key: "category",
      items: categories.map(cat => ({ id: cat.id.toString(), name: cat.name })),
      showMore: categories.length > 6,
   };

   const filterSections = [categorySection, ...staticFilterSections];

   if (!showFilters) return null;

   const handleCheckboxChange = (key, value) => {
      onFilterChange(key, value);
   };

   const handleRadioChange = (key, value) => {
      onFilterChange(key, value);
   };

   const isChecked = (key, value) => {
      if (key === 'rating' || key === 'price') {
         return selectedFilters[key] === value;
      }
      return selectedFilters[key].includes(value);
   };

   return (
      <div className="px-8 py-8 rounded-lg bg-gray-100 mb-8 dark:bg-dark-2">
         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {filterSections.map((section, index) => (
               <div key={index} className="space-y-6">
                  <h5 className="text-lg font-medium text-dark-1 mb-3 dark:text-white">
                     {section.title}
                  </h5>

                  <div className="space-y-4">
                     {section.items.map((item, itemIndex) => (
                        <div key={itemIndex} className="flex items-center justify-between gap-2">
                           {section.type === "checkbox" ? (
                              <div className='flex items-center gap-2 w-full'>
                                 <input
                                    type="checkbox"
                                    id={`filter-${section.key}-${itemIndex}`}
                                    checked={isChecked(section.key, item.value || item.id)}
                                    onChange={() => handleCheckboxChange(section.key, item.value || item.id)}
                                    className="form-checkbox h-4 w-4 text-dark-1 border-2 dark:text-white
                                    border-dark-1 bg-gray-100 checked:bg-dark-1 rounded focus:ring-dark-1" />
                                 <label htmlFor={`filter-${section.key}-${itemIndex}`} className="ml-2 text-dark-1 dark:text-white">
                                    {item.name}
                                 </label>
                              </div>
                           ) : section.type === "rating" ? (
                              <div className="flex items-center gap-2 w-full">
                                 <input
                                    type="radio"
                                    name={section.key}
                                    id={`radio-${section.key}-${itemIndex}`}
                                    checked={isChecked(section.key, item.value)}
                                    onChange={() => handleRadioChange(section.key, item.value)}
                                    className="h-5 w-5 border-2 border-dark-1 text-dark-1 dark:text-white focus:ring-dark-1
                                    focus:ring-offset-0"
                                 />
                                 <div className="flex items-center flex-1">
                                    <div className="flex mr-2">
                                       {[...Array(5)].map((_, i) => (
                                          <StarIcon
                                             key={i}
                                             className={`w-4 h-4 ${i < Math.floor(item.value) ?
                                                'text-yellow-400 fill-yellow-400' :
                                                'text-gray-300 fill-gray-300'}`}
                                          />
                                       ))}
                                    </div>
                                    <span className="text-dark-1 dark:text-white text-sm">{item.label}</span>
                                 </div>
                              </div>
                           ) : (
                              <div className="flex items-center">
                                 <input
                                    type="radio"
                                    name={section.key}
                                    id={`radio-${section.key}-${itemIndex}`}
                                    checked={isChecked(section.key, item.value)}
                                    onChange={() => handleRadioChange(section.key, item.value)}
                                    className="h-4 w-4 border-2 border-dark-1 dark:text-white text-dark-1 focus:ring-dark-1 focus:ring-offset-0"
                                 />
                                 <label
                                    htmlFor={`radio-${section.key}-${itemIndex}`}
                                    className="ml-2 text-dark-1 dark:text-white"
                                 >
                                    {item.name}
                                 </label>
                                 <span className="text-sm text-dark-1 dark:text-white whitespace-nowrap ml-auto">
                                    ({item.count})
                                 </span>
                              </div>
                           )}
                           <span className="text-sm text-dark-1 dark:text-white whitespace-nowrap">
                              ({item.count})
                           </span>
                        </div>
                     ))}
                  </div>

                  {section.showMore && (
                     <a href="#" className="block mt-2 text-sm font-medium text-[#6440FB] underline">
                        Show more
                     </a>
                  )}
               </div>
            ))}
         </div>
      </div>
   );
};

export default FiltersPanel;